
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 128 128"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8.2 107.6c9.2 4.3 18.4 8.7 27.6 13.1.4.3 1.1.3 1.6.3h21c1.2 0 1.4-.4 1.4-1.5-.1-6.2 0-12.4 0-18.6 0-.4-.1-.6-.1-1.2-.5.3-1 .4-1.4.6-6.4 2.8-13 5.1-20.2 4.2-2.8-.4-5.3-1.3-7.4-3.3-3.7-3.5-4.7-8.1-4.8-12.9-.1-4 .3-8 .8-12 .5-4.7 1.7-9.2 3.7-13.5 5.3-11.7 13.1-21.7 22.3-30.5 3-2.9 6.6-5.2 10-7.8.8-.6 1.6-.6 2.5 0 2.7 2 5.5 3.8 8 5.9 6.5 5.7 12 12.2 16.8 19.3 4.9 7.1 9 14.7 10.6 23.3 1.2 6.3 2 12.7.9 19.1-1.6 8.6-6.7 12.3-14.4 12.5-3.8.1-7.5-.7-11.1-2-2.6-.9-5.2-2-7.8-3V119c0 1.3.4 1.6 1.7 1.6 6.8-.1 13.5 0 20.3-.1.9 0 1.8-.3 2.6-.6 8.9-4.2 17.8-8.5 26.6-12.7 1.8-.9 1.8-.8 1.3-2.8-5-19.6-9.9-39.1-14.9-58.7-.2-.6-.5-1.3-1.1-1.9-2-2-4.1-3.9-6.1-5.8-3.9-3.6-7.8-7.2-11.8-10.8-5.3-4.8-10.5-9.5-15.8-14.4-2-1.9-4.2-3.8-6.2-5.8-.7-.6-1.2-.6-1.9.1-.9.9-1.9 1.7-2.8 2.5-4.1 3.8-8.2 7.6-12.3 11.3-4.4 4-8.7 8-13.2 12L25 41.6c-1.2 1.2-2.7 2.2-3.2 4.1C16.9 65.2 12 84.8 7 104.3c-.2 2.1 0 2.8 1.2 3.3z"}})])
          )
        }
      }
    